import * as React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { SettingsRoute } from "./Pages/SettingsRoute";
import { ButtonRoute } from "./Pages/ButtonRoute";
import { CustomActionRoute } from "./Pages/CustomActionRoute";

const outerTheme = createTheme({
  // palette: {
  //   primary: {
  //     main: "#428842",
  //   },
  // },
});

function App() {
  const router = createBrowserRouter([
    {
      path: "/settings",
      element: <SettingsRoute />,
    },
    {
      path: "/buttons",
      element: <ButtonRoute />,
      // element: <ProtectRoute Component={ButtonRoute} />,
    },
    {
      path: "/customaction",
      element: <CustomActionRoute />,
    },
    // {
    //   path: "/relatedlist",
    //   element: <RelatedList />,
    // },
    // {
    //   path: "/webtab",
    //   element: <Webtab />,
    // },
    // {
    //   path: "/businesscard",
    //   element: <Businesscard />,
    // },
  ]);
  return <RouterProvider router={router} />;
}

const Base = () => {
  return (
    <React.Fragment>
      <ThemeProvider theme={outerTheme}>
        <SnackbarProvider>
          <CssBaseline />
          <App />
        </SnackbarProvider>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default Base;
